<div class="global-conntect-app-dialog">
    <sc-flex [fitHeight]="true" [vertical]="true">
        <sc-flex-fitting-content [vertical]="true">
            <img src="/assets/default/icons/app-store/{{store}}-badge-{{translationService.language}}.{{extension}}"
                class="app-badge {{store}}-badge" alt="" />
            <div class="qr-code-box">
                <qrcode *ngIf="qrCodeUrl" [qrdata]="qrCodeUrl" [scale]="8"></qrcode>
            </div>
        </sc-flex-fitting-content>
        <sc-actionbar>
            <sc-content-spacer [grow]="true"></sc-content-spacer>
            <sc-close-button buttonStyle="flat" [mat-dialog-close]="true" cdkFocusInitial></sc-close-button>
        </sc-actionbar>
    </sc-flex>
</div>
